import {TranslocoService} from '@ngneat/transloco';
import * as moment from 'moment-timezone';
import {MeasurementPropertiesErrors} from './measurement-properties-errors';
import {MeasurementPersistRequestCsv} from '../../model/import-csv/measurement-persist-request-csv';
import {MeasurementImportCsv} from '../../model/import-csv/measurement-import-csv';
import {Inject} from '@angular/core';
import {CsvErrors} from '../../shared/csv-validation/csv-errors';

export class MeasurementCsvErrors extends CsvErrors<MeasurementPropertiesErrors, MeasurementPersistRequestCsv | MeasurementImportCsv> {
  constructor(@Inject(TranslocoService) i18n: TranslocoService) {
    super(i18n, MeasurementPropertiesErrors);
  }

  public validDate(measurement: MeasurementPersistRequestCsv | MeasurementImportCsv, property: string): boolean {
    const nameRegexp: RegExp = /^[0-9:T-]+(?:\.\d{3})?Z$/;
    if (measurement[property] == null || !nameRegexp.test(measurement[property]) || (!moment(measurement[property]).isValid() && !moment(Number.parseInt(measurement[property])).isValid())) {
      this.addCsvMachineError(property, {
        message: "noValidDate",
        params: {
          field: this.propertiesErrors.getTranslation(property).toLowerCase(),
          value: measurement[property],
        }
      });
      return false;
    }
    return true;
  }

}
